import {
  HEAT_MAP_SECTORS as CATALOG_HEAT_MAP_SECTORS,
  QUOTE_GROUP_SYMBOLS,
  type HeatMapSectorDefinition,
  type QuoteGroupId
} from './instrumentCatalog';

export type {
  HeatMapSectorDefinition,
  QuoteGroupId
};

export interface QuoteGroupDefinition {
  id: QuoteGroupId;
  label: string;
}

export const QUOTE_MONITOR_GROUPS: QuoteGroupDefinition[] = [
  {
    id: 'tech',
    label: 'Tech'
  },
  {
    id: 'etfs',
    label: 'ETFs'
  },
  {
    id: 'value',
    label: 'Value'
  }
];

export const HEAT_MAP_SECTORS: readonly HeatMapSectorDefinition[] =
  CATALOG_HEAT_MAP_SECTORS;

const QUOTE_GROUP_SETS: Record<QuoteGroupId, ReadonlySet<string>> = {
  tech: new Set(QUOTE_GROUP_SYMBOLS.tech),
  etfs: new Set(QUOTE_GROUP_SYMBOLS.etfs),
  value: new Set(QUOTE_GROUP_SYMBOLS.value)
};

export function isQuoteGroupId(
  value: string | undefined
): value is QuoteGroupId {
  return (
    value === 'tech' ||
    value === 'etfs' ||
    value === 'value'
  );
}

export function symbolMatchesQuoteGroup(
  groupId: QuoteGroupId,
  symbol: string
): boolean {
  return QUOTE_GROUP_SETS[groupId].has(
    normalizeSymbol(symbol)
  );
}

export function getQuoteGroupSymbols(
  groupId: QuoteGroupId,
  universe: readonly string[]
): string[] {
  if (universe.length === 0) {
    return [...QUOTE_GROUP_SYMBOLS[groupId]];
  }

  const availableSymbols = new Set(
    universe.map(normalizeSymbol)
  );

  return QUOTE_GROUP_SYMBOLS[groupId].filter((symbol) => {
    return availableSymbols.has(symbol);
  });
}

export function getHeatMapSymbolsForSector(
  sectorId: string,
  universe: readonly string[]
): string[] {
  const sector = HEAT_MAP_SECTORS.find(
    (item) => item.id === sectorId
  );

  if (!sector) {
    return [];
  }

  if (universe.length === 0) {
    return [...sector.symbols];
  }

  const availableSymbols = new Set(
    universe.map(normalizeSymbol)
  );

  return sector.symbols.filter((symbol) => {
    return availableSymbols.has(symbol);
  });
}

function normalizeSymbol(symbol: string): string {
  return symbol.trim().toUpperCase();
}